import * as dc from "@/components/layout/list/defaultType";
import { RefObject } from "react";
import { DataListParams, DataListProp, DataParams, LayoutProps, TransitionType } from "../../layoutType";
import { App, FormInstance } from "antd";
import {
  runFormFunction,
  calSubListFieldsTotal,
  setSubListFieldOrder,
  runSubListCommand,
  getMatchingData,
  getFormMemo,
  convertSubListToFormDataDetail,
  setFormClass,
  calcFieldsValue,
  getInputValuesCheck,
} from "../../input/inputFunction";
import dayjs from "dayjs";
import { Debug } from "@/util/debug";
import { CalcValueProps, DataCols, DataColumn, DataColumnField, DataInputCommonParams } from "../../input/inputType";
import { getFormValues, setFormValues } from "../defaultTypeCheck";
import { checkEmpty, checkEmptyValue, getJsonFromStr, getStrFromJson } from "@/util/stringutil";
import { Flex } from "@radix-ui/themes";
import { fetchHost, fetchStatusText, fetchUtil } from "@/util/fetchutil";
import { getIntArray } from "@/util/arrayutil";
import {
  fillCheckValues,
  getPrevTemp,
  getRoastingShowTimeCheck,
  RoastingCheckCount,
  roastingIndexKeyStr,
  roastingProfileCols,
  roastingSummaryFieldIdExp,
  roastingTimerList,
  summaryRefresh,
  updateCompareProfile,
} from "../../inputCols/roastingCols";
import { roastingProfileClipboard } from "../../inputCols/clipboard";
import { enLocale } from "@/i18n/routing";
import { scrollToDataPosition } from "../../data/data";
import { getSummaryValues, listEditClickCommon } from "../../data/list/list";
import Icon from "@/components/common/icon/icon";
import { getRoastingSeriesCalcLossRatio, getRoastingSeriesInput } from "@/util/roastingpredict";
import { timelineChartChange } from "../../input/timelineChart";

export const RoastingResult = (props: DataListProp): DataListParams | undefined => {
  const t = props.t;
  const ta = props.ta;
  const result = props.result;
  const params = props.params;
  const form = props.form;
  const formMemo = props.formMemo;
  const setValueList = props.setValueList;
  const formFunction = props.formFunction;
  const dataFunction = props.dataFunction;
  const alertContext = props.alertContext;
  const message = props.message;

  // const { message } = App.useApp();

  const roasting_greenbean_fields = ["greenbean_roaster_seq", "greenbean_mass", "greenbean_percent"];
  const setRoastingProfileUse = (values?: any, force?: boolean) => {
    Debug("setRoastingProfileUse", values);
    const roasting_profile_use =
      force !== undefined
        ? force
        : values !== undefined
          ? values["roasting_profile_use"]
          : form?.current?.getFieldInstance("roasting_profile_use")
            ? form.current.getFieldValue("roasting_profile_use")
            : undefined;
    //const formObj = document.querySelector(roastingFormName) as HTMLFormElement;
    setFormClass(dataFunction?.current, { roasting_profile_use: roasting_profile_use ?? false });
  };
  const seqSelectWithList: string[] = [];
  const yearSelectWithList: string[] = [];
  for (let i = 0; i < 20; i++) {
    seqSelectWithList.push("greenbean_roaster_seq_" + i);
    yearSelectWithList.push("greenbean_roaster_year_" + i);
  }
  const setGreenbeanOrder = () => {
    setTimeout(() => {
      if (form?.current && formFunction?.current) {
        setSubListFieldOrder(form.current, formFunction.current, "roasting_greenbean_comb", "greenbean_order");
      }
    }, 150);
  };

  const calGreenbeanMass = (calcLoss?: boolean) => {
    if (form?.current && formFunction?.current) {
      calSubListFieldsTotal(
        form.current,
        formFunction.current,
        "roasting_greenbean_comb",
        "greenbean_total_mass",
        "greenbean_mass",
        "greenbean_percent", //"label", //"roasting_greenbean_percent",
        { greenbean_moisture: "greenbean_moisture" },
      );
      if (calcLoss) {
        calcRoastingLoss();
      }
    }
  };
  const setMoistureAvg = (result: any, data: any, setField: string, minField?: string, maxField?: string) => {
    const temp_greenbean_moisture_avg = getMoistureAvg(data, minField, maxField);
    if (temp_greenbean_moisture_avg !== undefined) {
      result[setField] = temp_greenbean_moisture_avg;
    }
  };

  const getMoistureAvg = (data: any, minField?: string, maxField?: string) => {
    if (data) {
      const temp_greenbean_moisture_min: number | undefined = data[minField ?? "greenbean_moisture_min"];
      const temp_greenbean_moisture_max: number | undefined = data[maxField ?? "greenbean_moisture_max"];
      const temp_greenbean_moisture_avg =
        temp_greenbean_moisture_min && temp_greenbean_moisture_max
          ? (temp_greenbean_moisture_min + temp_greenbean_moisture_max) / 2
          : temp_greenbean_moisture_min
            ? temp_greenbean_moisture_min
            : temp_greenbean_moisture_max;
      return temp_greenbean_moisture_avg ? temp_greenbean_moisture_avg / 10 : undefined;
    } else {
      return undefined;
    }
  };
  const setGreenbeanInfo = () => {
    if (form?.current && formFunction?.current) {
      const { run, result } = runFormFunction(formFunction.current, "roasting_greenbean_comb", "getCount");
      const set_values: Record<string, any> = {};

      const greenbean_country_list: string[] = [];
      const greenbean_variety_list: string[] = [];
      const greenbean_grade_list: string[] = [];
      const greenbean_grade_detail_list: string[] = [];
      const greenbean_process_list: string[] = [];
      const greenbean_variety_etc_list: string[] = [];
      const greenbean_process_etc_list: string[] = [];
      const moisture_values: Record<string, number> = {};

      getIntArray(result, 0, (i) => {
        const temp_result = runFormFunction(formFunction?.current, "greenbean_year_" + i, "selectData");
        const temp_data = temp_result.result;
        if (temp_data) {
          const temp_greenbean_country_code = temp_data["greenbean_country_code"];
          const temp_greenbean_variety_list = temp_data["greenbean_variety_list"];
          const temp_greenbean_grade = temp_data["greenbean_grade"];
          const temp_greenbean_grade_detail = temp_data["greenbean_grade_detail"];
          const temp_greenbean_process = temp_data["greenbean_process"];
          const temp_greenbean_variety_etc = temp_data["greenbean_variety_etc"];
          const temp_greenbean_process_etc = temp_data["greenbean_process_etc"];
          const temp_greenbean_moisture_min: number | undefined = temp_data["greenbean_moisture_min"];
          const temp_greenbean_moisture_max: number | undefined = temp_data["greenbean_moisture_max"];

          setMoistureAvg(moisture_values, temp_data, "greenbean_moisture_" + i);

          if (!checkEmpty(temp_greenbean_country_code) && !greenbean_country_list.includes(temp_greenbean_country_code)) {
            greenbean_country_list.push(temp_greenbean_country_code);
          }

          if (!checkEmpty(temp_greenbean_variety_list) && typeof temp_greenbean_variety_list === "string") {
            const temp_arr = temp_greenbean_variety_list.split(",");
            temp_arr.forEach((temp) => {
              if (!greenbean_variety_list.includes(temp)) {
                greenbean_variety_list.push(temp);
              }
            });
          }

          if (!checkEmpty(temp_greenbean_grade) && typeof temp_greenbean_grade === "string") {
            const temp_arr = temp_greenbean_grade.split(",");
            temp_arr.forEach((temp) => {
              if (!greenbean_grade_list.includes(temp)) {
                greenbean_grade_list.push(temp);
              }
            });
          }

          if (!checkEmpty(temp_greenbean_grade_detail) && typeof temp_greenbean_grade_detail === "string") {
            const temp_arr = temp_greenbean_grade_detail.split(",");
            temp_arr.forEach((temp) => {
              if (!greenbean_grade_detail_list.includes(temp)) {
                greenbean_grade_detail_list.push(temp);
              }
            });
          }

          if (!checkEmpty(temp_greenbean_process) && typeof temp_greenbean_process === "string") {
            const temp_arr = temp_greenbean_process.split(",");
            temp_arr.forEach((temp) => {
              if (!greenbean_process_list.includes(temp)) {
                greenbean_process_list.push(temp);
              }
            });
          }

          if (!checkEmpty(temp_greenbean_variety_etc)) {
            greenbean_variety_etc_list.push(temp_greenbean_variety_etc);
          }
          if (!checkEmpty(temp_greenbean_process_etc)) {
            greenbean_process_etc_list.push(temp_greenbean_process_etc);
          }

          // Debug(i, temp_result.result);
        }
      });
      if (!checkEmpty(greenbean_variety_etc_list)) {
        greenbean_variety_list.push(dc.input_direct);
      }
      if (!checkEmpty(greenbean_process_etc_list)) {
        greenbean_process_list.push(dc.input_direct);
      }
      const setValues = {
        ...moisture_values,
        greenbean_country_list,
        greenbean_variety_list,
        greenbean_grade_list,
        greenbean_grade_detail_list,
        greenbean_process_list,
        greenbean_variety_etc: greenbean_variety_etc_list.join(","),
        greenbean_process_etc: greenbean_process_etc_list.join(","),
      };
      // Debug(setValues);
      form.current.setFieldsValue(setValues);
      runFormFunction(formFunction.current, "greenbean_variety_list", "checkInputDirect", false);
      runFormFunction(formFunction.current, "greenbean_process_list", "checkInputDirect", false);
    }
  };

  const addGreenbeanList = (insertName?: boolean) => {
    if (form?.current && formFunction?.current) {
      const greenbean_seq = form?.current?.getFieldValue("roasting_greenbean_seq");
      const greenbean_mass = form?.current?.getFieldValue("roasting_greenbean_mass");
      const greenbean_year = form?.current?.getFieldValue("roasting_greenbean_year");
      if (!checkEmpty(greenbean_seq)) {
        const { run, result } = runFormFunction(formFunction?.current, "roasting_greenbean_comb", "getCount");
        const seqList: string[] = [];
        for (let i = 0; i < result; i++) {
          seqList.push("greenbean_roaster_seq_" + i);
        }
        const seqValues = form?.current?.getFieldsValue(seqList);
        const checkSeq = Object.keys(seqValues).some((item) => {
          return greenbean_seq == seqValues[item];
        });

        if (checkSeq) {
          const alertP = alertContext?.setProp;
          if (alertP) {
            alertP({
              open: true,
              title: ta("roasting_greenbean_add"),
              description: ta("roasting_greenbean_exist"),
              useCancel: false,
              useOk: true,
              okFunction: () => {
                setTimeout(() => {
                  setRoastingProfileUse();
                }, dc.setTimeoutDelay);
              },
            });
          } else {
            alert(checkSeq);
          }
          return;
        }

        if ((insertName ?? true) && result === 0) {
          const check_values = form?.current?.getFieldsValue(["roasting_name_locale", "roasting_name"]);
          const check_empty = check_values ? Object.keys(check_values).every((key) => checkEmpty(check_values[key])) : false;
          if (check_empty) {
            const result = runFormFunction(formFunction?.current, "roasting_greenbean_seq", "selectData");
            // Debug(result.result);
            if (result && result.result) {
              form?.current?.setFieldsValue({
                roasting_name_locale: result.result["greenbean_name_locale"],
                roasting_name: result.result["greenbean_name"],
              });
            }
          }
        }

        runFormFunction(formFunction.current, "roasting_greenbean_comb", "setCount", result + 1);
        const setResult: Record<string, any> = {};
        setResult["greenbean_roaster_seq_" + result] = greenbean_seq;
        setResult["greenbean_mass_" + result] = greenbean_mass;
        if (!checkEmpty(greenbean_year)) {
          setResult["greenbean_year_" + result] = greenbean_year;
        }
        //Debug(setResult);
        setFormValues(form.current, setResult);
        checkSingleOrigin(form.current, "roasting_single_origin", result + 1 <= 1);
        setGreenbeanOrder();
        setTimeout(() => {
          //Debug("greenbean_year_" + result);
          runFormFunction(formFunction?.current, "greenbean_year_" + result, "changeLoad");
          setTimeout(() => {
            setGreenbeanInfo();
            calGreenbeanMass(!(insertName ?? true));
          }, dc.setTimeoutDelay / 2);
        }, 150);
      }

      // setTimeout(() => {
      // }, dc.setTimeoutDelay);
      //alert("plus : " + setResult.result);
    }
  };
  const roasting_greenbean: DataColumnField = {
    ...dc.select,
    inputClassName: dc.greenbeanSeqWidth,
    widthFull: true,
    dataUrl: "/api/roaster/greenbean/default/code",
    dataProp: {
      load: (data, select_data, name, index) => {
        //Debug(data, select_data, name, index);
        //runFormFunction(formFunction?.current);
      },
    },
    dataLabel: {
      value: "greenbean_roaster_seq",
      label: [
        params?.locale === enLocale
          ? { field: "greenbean_name", subs: "greenbean_nick" }
          : { field: "greenbean_name_locale", subs: "greenbean_nick_locale" },
      ],
      labelSort: true,
    },
    selectPropOption: { reloadButton: false },
    create: { dataProp: { firstReload: true } },
    // onChange: (data) => {},
  };

  const checkSingleOrigin = (form: FormInstance, field: string, check: boolean) => {
    form.setFieldValue(field, check);
  };
  const calcRoastingLoss = () => {
    const baseInp = document.getElementById("roasting_mass_calc_base") as HTMLInputElement;
    const baseNo = baseInp ? Number(baseInp.value) : 1;
    const base = isNaN(baseNo) ? 1 : baseNo;
    calcFieldsValue(form?.current, "roasting_mass", "/", "greenbean_total_mass", "roasting_mass_calc", 1, base);
    calcFieldsValue(form?.current, "roasting_mass", "loss", "greenbean_total_mass", "roasting_loss", 2);
    //roasting_bean_moisture,green_bean_moisture
    if (form?.current) {
      const gbm = form.current.getFieldValue("greenbean_moisture");
      const rbm = form.current.getFieldValue("roasting_moisture");
      const gbmass = form.current.getFieldValue("greenbean_total_mass");
      const rbmass = form.current.getFieldValue("roasting_mass");
      const rbl = form.current.getFieldValue("roasting_loss");
      const result =
        gbm && rbm && gbmass && rbmass && rbl
          ? Number(100 - ((100 - rbl) * rbmass * (100 - rbm)) / (gbmass * (100 - gbm))).toFixed(2)
          : null;
      form.current.setFieldsValue({ roasting_organic_loss: result });
    }
  };
  const setRoastingSeq = () => {
    const form_current = form?.current;
    const form_function = formFunction?.current;
    const form_memo = formMemo?.current;
    const { run, result } = runFormFunction(form_function, "roasting_seq", "selectData");

    //Debug(result, subList);
    if (result && form_current) {
      const value = result["roasting_seq"];
      const exField = [
        "roaster_seq",
        "roasting_country_list",
        "roasting_grade_detail_list",
        "roasting_grade_list",
        "roasting_result_seq_ref",
        "roasting_result_year_ref",
        "roasting_seq",
        "roasting_use",
        "roasting_user_seq",
        "roasting_variety_list",
        "edit_at",
      ];
      const matching_values = getMatchingData(form_current, form_memo, result, exField);
      if (checkEmpty(form_current.getFieldValue("roasting_result_date"))) {
        const temp_date = dayjs(new Date());
        matching_values["roasting_result_date"] = temp_date;
        matching_values["roasting_result_year"] = temp_date;
      }
      // Debug(matching_values);
      form_current.setFieldsValue(matching_values);
      const batch_auto = form_current.getFieldValue("roasting_batch_auto");
      const fetch_option = { ...dc.fetchOption };
      if (batch_auto) {
        const batch_no = form_current.getFieldValue("roasting_batch_no");
        const dataMode = dataFunction?.current && dataFunction.current["getDataMode"] ? dataFunction?.current["getDataMode"]() : undefined;
        const org_data = dataFunction?.current && dataFunction.current["getData"] ? dataFunction?.current["getData"]() : undefined;
        const org_batch_no = org_data ? org_data["roasting_batch_no"] : undefined;
        const batch_date = form_current.getFieldValue("roasting_result_date");
        if (batch_date && (!batch_no || dataMode === "write" || (dataMode === "edit" && !org_batch_no))) {
          fetch_option["body"] = JSON.stringify({
            roasting_result_date: dayjs(batch_date).format("YYYYMMDD"),
            roasting_batch_auto: 1,
          });
        }
      }

      setRoastingProfileUse();
      setTimeout(() => {
        fillCheckValues(form.current);
      }, dc.setTimeoutDelay);

      fetchHost("/api/roaster/roasting/default/greenbean/" + value, fetch_option, props.params?.auth, (data: any) => {
        const result = data && data.result ? data && data.result : undefined;
        if (result) {
          const list_data = result["roasting_default_greenbean"];
          const roasting_batch_no = result["roasting_batch_no"];
          if (list_data) {
            runFormFunction(form_function, "roasting_greenbean_comb", "setCount", list_data.length);
            setTimeout(() => {
              const subList = getFormMemo(form_memo, "roasting_greenbean_comb", "subList");
              const convert = convertSubListToFormDataDetail(
                "roasting_greenbean_comb",
                subList,
                ["greenbean_roaster_seq", "greenbean_mass", "greenbean_order"],
                list_data,
              );
              const sub_matcing_values = getMatchingData(form_current, form_memo, convert);
              //Debug(data.result, convert, sub_matcing_values);
              if (roasting_batch_no !== undefined) {
                sub_matcing_values["roasting_batch_no"] = roasting_batch_no;
              }
              form_current.setFieldsValue(sub_matcing_values);
              setTimeout(() => {
                getIntArray(list_data.length, 0, (i) => {
                  runFormFunction(form_function, "greenbean_roaster_seq_" + i, "setNowValueTooltip");
                  runFormFunction(form_function, "greenbean_year_" + i, "changeLoad");
                });
              }, dc.setTimeoutShort);
              setTimeout(() => {
                setGreenbeanInfo();
                calGreenbeanMass(true);
              }, dc.setTimeoutDelay);
            }, dc.setTimeoutDelay);
          }
        }
      });
    } else {
      setRoastingProfileUse();
    }
  };
  const ResultInit = (data: any, params: DataParams) => {
    const roasting_seq = form?.current?.getFieldValue("roasting_seq");
    const sub_data = data ? data["roasting_result_greenbean"] : undefined;
    Debug("Run ResultInit", params, data);
    // Debug(roasting_seq, sub_data);
    if (!checkEmpty(roasting_seq) && checkEmpty(sub_data)) {
      // setTimeout(() => {
      //   setRoastingSeq();
      // }, dc.setTimeoutDelay);
      // setTimeout(() => {
      //   setRoastingProfileUse(data);
      // }, dc.setTimeoutDelay * 2);
    } else {
      setTimeout(() => {
        calcRoastingLoss();
        setRoastingProfileUse(data);
      }, dc.setTimeoutDelay * 3);
    }
    const viewMode = params.dataMode === "view";
    if (params) {
      form?.current?.setFieldsValue({
        roasting_check_show: !viewMode,
        roasting_compare_show: false,
      });
      setFormClass(dataFunction?.current, { hidden_roasting_check: viewMode, compare_item_use: false });
    }

    if (params && params.dataMode === "edit" && params.setTimer) {
      const end = data !== undefined && !checkEmpty(data.roasting_end_term) ? true : false;
      const start = data && !checkEmpty(data[roastingIndexKeyStr]) ? data[roastingIndexKeyStr] : undefined;
      Debug("check timeout", Math.abs(dayjs().diff(start)), !end);
      if (start !== undefined && Math.abs(dayjs().diff(start)) < 3600000 && !end) {
        params.setTimer({ timer: roastingIndexKeyStr, start });
      }
    }
  };
  const roasting_names: DataCols = {
    roasting_name_locale: {
      ...dc.inputFull,
      minLength: params?.locale !== enLocale ? 3 : undefined,
      maxLength: 300,
      showCount: true,
      labelClassName: dc.strongLabelClassName,
      required: params?.locale !== enLocale ? true : undefined,
      read: { variant: "borderless" },
    },
    roasting_name: {
      ...dc.inputFull,
      minLength: params?.locale === enLocale ? 3 : undefined,
      maxLength: 300,
      showCount: true,
      labelClassName: dc.strongLabelClassName,
      required: params?.locale === enLocale ? true : undefined,
      read: { variant: "borderless" },
    },

    roasting_nick_locale: {
      ...dc.inputFull,
      maxLength: 300,
      showCount: true,
      read: { display: "notNull", variant: "borderless" },
    },
    roasting_nick: {
      ...dc.inputFull,
      maxLength: 300,
      showCount: true,
      read: { display: "notNull", variant: "borderless" },
    },
  };
  const roasting_machine_seq: DataColumnField = {
    ...dc.selectSearch,
    inputClassName: dc.inputCountryClassName,
    selectFilter: { equip_type: "RSTR" },
    dataUrl: "/api/roaster/item/equip/code",
    dataProp: {
      // load: (data, select_data) => {
      //   Debug(data, select_data);
      // },
    },
    dataLabel: {
      value: "roaster_equip_seq",
      label: [
        params?.locale === enLocale
          ? { field: "equip_nick", subs: "equip_name" }
          : { field: "equip_nick_locale", subs: "equip_name_locale" },
      ],
      labelSort: true,
    },
    read: { variant: "borderless", display: "notNull" },
    onChange: (data) => {},
  };

  const roasting_public_stage: DataCols = {
    public_stage_explain: {
      label: "public_stage",
      labelClassName: dc.mobileShow,
      read: {
        display: "notNull",
        displayCheckIds: ["public_stage_roaster", "public_stage_cafe", "public_stage_customer", "public_stage_normal"],
      },
      fieldId: {
        public_stage_roaster: {
          ...dc.number,
          placeholder: "public_stage_roaster",
          saveData: false,
          allowClear: false,
          inputClassName: dc.inputAuthWidth + " input-text-center",
          disabled: true,
          readOnly: true,
          variant: "borderless",
          noItem: true,
        },
        public_stage_cafe: {
          ...dc.number,
          placeholder: "public_stage_cafe",
          saveData: false,
          allowClear: false,
          inputClassName: dc.inputAuthWidth + " input-text-center",
          disabled: true,
          readOnly: true,
          variant: "borderless",
          noItem: true,
        },
        public_stage_customer: {
          ...dc.number,
          placeholder: "public_stage_customer",
          saveData: false,
          allowClear: false,
          inputClassName: dc.inputAuthWidth + " input-text-center",
          disabled: true,
          readOnly: true,
          variant: "borderless",
          noItem: true,
        },
        public_stage_normal: {
          ...dc.number,
          placeholder: "public_stage_normal",
          saveData: false,
          allowClear: false,
          inputClassName: dc.inputAuthWidth + " input-text-center",
          disabled: true,
          readOnly: true,
          variant: "borderless",
          noItem: true,
        },
      },
    },
    public_stage: {
      labelClassName: dc.mobileHidden,
      read: {
        display: "notNull",
        displayCheckIds: ["public_stage_roaster", "public_stage_cafe", "public_stage_customer", "public_stage_normal"],
      },
      fieldId: {
        public_stage_roaster: {
          ...dc.select,
          inputClassName: dc.inputAuthWidth,
          codeGroup: "PBST",
          selectPropOption: { reloadButton: false },
          create: { defaultValue: "ALL" },
          read: { inputClassName: dc.inputAuthWidth + " text-center", readOnly: true },
        },
        public_stage_cafe: {
          ...dc.select,
          inputClassName: dc.inputAuthWidth,
          codeGroup: "PBST",
          selectPropOption: { reloadButton: false },
          create: { defaultValue: "DTL" },
          read: { inputClassName: dc.inputAuthWidth + " text-center", readOnly: true },
        },
        public_stage_customer: {
          ...dc.select,
          inputClassName: dc.inputAuthWidth,
          codeGroup: "PBST",
          selectPropOption: { reloadButton: false },
          create: { defaultValue: "NRML" },
          read: { inputClassName: dc.inputAuthWidth + " text-center", readOnly: true },
        },
        public_stage_normal: {
          ...dc.select,
          inputClassName: dc.inputAuthWidth,
          codeGroup: "PBST",
          selectPropOption: { reloadButton: false },
          create: { defaultValue: "LST" },
          read: { inputClassName: dc.inputAuthWidth + " text-center", readOnly: true },
        },
      },
    },
    roasting_auth: {
      ...dc.roasterAuth,
      inputClassName: dc.inputCountryClassName,
      maxLength: 45,
      showCount: true,
      read: { variant: "borderless", display: "notNull" },
    },
  };
  switch (params?.page.page ?? "") {
    //로스팅기본 정보
    //--info--{
    //--info--"table":{"system_TABLE_SCHEMA":"clm_roaster","system_TABLE_NAME":"roasting_default","system_table_pk":["roaster_seq","roasting_seq"],"system_table_manual_increment":"roasting_seq","system_table_page":"RoastingDefault","system_table_path":"roaster/roasting/default","system_table_page_name":"RoastingDefault","system_table_auth":["GUEST","USER","ADMIN"],"system_select_auth":["roaster"],"system_roaster_auth":"ROASTER","system_roaster_auth_field":["roasting_auth"],"system_table_mapper":"roaster","system_table_detail_result":"detail_result","system_table_search_column":["roasting_grade_list","roasting_country_list","roasting_variety_list"],"system_table_search_select":["roasting_name_locale","roasting_name"],"system_table_order_column":["roasting_name_locale","roasting_name","roasting_country_list"],"system_table_default_name_column":"roasting_name_locale","system_table_en_name_column":"roasting_name","system_table_use_column":"roasting_use"}
    //--info--}

    //생두목록 정보
    //--info--{
    //--info--"table":{"system_TABLE_SCHEMA":"clm_roaster","system_TABLE_NAME":"roasting_default_greenbean","system_table_pk":["roaster_seq","roasting_seq","greenbean_roaster_seq"],"system_table_page":"RoastingDefaultGreenbean","system_table_path":"roaster/roasting/default/greenbean","system_table_page_name":"RoastingDefaultGreenbean","system_table_auth":["GUEST","USER","ADMIN","SADMIN"],"system_select_auth":["roaster"],"system_roaster_auth":"ROASTER","system_roaster_auth_field":[],"system_table_mapper":"roaster","system_table_detail_result":"roasting_greenbean_list"}
    //--info--}

    case "RoastingDefault":
      return {
        ...result,
        dataFetch: {
          fetchUrl: "/api/roaster/roasting/default/detail/",
          saveFetch: { fetchUrl: "/api/roaster/roasting/default/edit" },
        },
        listFetch: { fetchUrl: "/api/roaster/roasting/default/list" },
        dataResultName: "detail_result",
        dataName: "RoastingDefaultData",
        dataInit: () => {
          calGreenbeanMass();
        },
        dataCols: {
          roasting_seq: { ...dc.hidden },
          ...roasting_names,
          // roasting_user_seq: { ...dc.select },
          // roasting_result_year_ref: { ...dc.number },
          // roasting_result_seq_ref: { ...dc.number },
          roasting_batch_auto: {
            ...dc.use,
          },
          roasting_machine_seq: roasting_machine_seq,
          div_1: dc.itemDiv,
          roasting_greenbean_comb_explain: {
            label: "blank",
            labelClassName: dc.mobileHidden,
            valueClassName: "flex-col lg:flex-row mobile_multi",
            fieldId: {
              roasting_greenbean_comb_explain_main: {
                flexClassName: "w-full flex-row",
                fieldId: {
                  roasting_greenbean_remove_explain: {
                    ...dc.buttonDefault("Minus", undefined, "default", undefined, "px-2 invisible"),
                    read: { display: false },
                    saveData: false,
                    onClick: (e) => {},
                  },
                  roasting_greenbean_name_insert_explain: {
                    ...dc.buttonDefault("PencilSimpleLine", undefined, "default", undefined, "px-2 invisible"),
                    read: { display: false },
                    saveData: false,
                    onClick: (e) => {},
                  },
                  roasting_greenbean_seq_explain: {
                    ...dc.inputFull,
                    placeholder: "roasting_greenbean_explain",
                    saveData: false,
                    allowClear: false,
                    inputClassName: "text-center",
                    disabled: true,
                    readOnly: true,
                    variant: "borderless",
                    noItem: true,
                  },
                },
              },
              roasting_greenbean_comb_explain_sub: {
                flexClassName: "ml-0 mt-2 lg:ml-2 lg:mt-0 " + dc.mobileHidden,
                fieldId: {
                  roasting_greenbean_mass_explain: {
                    ...dc.number,
                    placeholder: "greenbean_mass",
                    saveData: false,
                    allowClear: false,
                    inputClassName: dc.greenbeanMassWidth + " input-text-center",
                    disabled: true,
                    readOnly: true,
                    variant: "borderless",
                    noItem: true,
                  },
                  roasting_greenbean_percent_explain: {
                    ...dc.number,
                    placeholder: "ratio_label",
                    saveData: false,
                    allowClear: false,
                    inputClassName: dc.inputNumberClassName + " input-text-center",
                    disabled: true,
                    readOnly: true,
                    variant: "borderless",
                    noItem: true,
                  },
                },
              },
            },
          },
          roasting_greenbean_list: {
            labelClassName: dc.mobileHidden,
            read: { itemClassName: "hidden" },
            valueClassName: "flex-col lg:flex-row mobile_multi",
            fieldId: {
              roasting_greenbean_list_main: {
                flexClassName: "w-full flex-row",
                fieldId: {
                  roasting_greenbean_add: {
                    ...dc.buttonDefault(
                      "Plus",
                      () => {
                        addGreenbeanList();
                      },
                      "default",
                    ),
                    tooltip: "add_label",
                  },
                  roasting_greenbean_seq: {
                    ...dc.selectSearch,
                    inputClassName: dc.greenbeanSeqWidth,
                    dataUrl: "/api/roaster/greenbean/default/code",
                    dataProp: {
                      // load: (data, select_data) => {
                      //   Debug(data, select_data);
                      // },
                    },
                    widthFull: true,
                    dataLabel: {
                      value: "greenbean_roaster_seq",
                      label: [
                        params?.locale === enLocale
                          ? { field: "greenbean_name", subs: "greenbean_nick" }
                          : { field: "greenbean_name_locale", subs: "greenbean_nick_locale" },
                      ],
                      labelSort: true,
                    },
                    create: { dataProp: { firstReload: true } },
                    selectPropOption: { reloadButtonFront: true },
                    selectWithLoad: seqSelectWithList,
                    onChange: (data) => {},
                    onPressEnter: (e) => {
                      addGreenbeanList();
                    },
                    tooltip: true,
                    tooltipTransition: false,
                    saveData: false,
                  },
                },
              },
              roasting_greenbean_list_sub: {
                flexClassName: "ml-0 mt-2 lg:ml-2 lg:mt-0 ",
                fieldId: {
                  roasting_greenbean_mass: {
                    ...dc.mass,
                    inputClassName: dc.greenbeanMassWidth + dc.textLastClassName,
                    saveData: false,
                    placeholder: "greenbean_mass",
                    onPressEnter: (e) => {
                      addGreenbeanList();
                    },
                    // inputClassName: dc.mass.inputClassName + " " + dc.inputCountryClassName
                  },
                  roasting_greenbean_percent: {
                    ...dc.percent,
                    saveData: false,
                    placeholder: "ratio_label",
                    onPressEnter: (e) => {
                      addGreenbeanList();
                    },
                    // inputClassName: dc.mass.inputClassName + " " + dc.inputCountryClassName
                  },
                },
              },
            },
          },
          div_2: { ...dc.itemDiv, read: { itemClassName: "hidden" } },
          roasting_greenbean_comb: {
            //labelClassName: "justify-center",
            label: "roasting_greenbean_count",
            // labelInput: {
            //   fieldId: "greenbean_percent",
            //   ...dc.percent,
            //   tooltip: "ratio_label",
            //   onChange: (e) => {
            //     //Debug(e);
            //     //calGreenbeanMass();
            //   },
            // },
            labelMyAuto: false,
            //inputType: "display",
            // subListEmptyLabel: "empty",
            // subListEmptyValue: <div className="w-full text-center">{t("roasting_greenbean_list_empty")}</div>,
            subList: { target: "roasting_default_greenbean", labelField: "COLUMN_NAME" },
            subListKeys: ["greenbean_roaster_seq"],
            minLength: 1,
            valueClassName: "flex-col lg:flex-row mobile_multi",

            fieldId: {
              roasting_greenbean_comb_main: {
                flexClassName: "w-full flex-row",
                fieldId: {
                  greenbean_remove: {
                    ...dc.buttonDefault("Minus", undefined, "default"),
                    read: { display: false },
                    saveData: false,
                    onClick: (e) => {
                      //Debug(e);
                      if (form?.current && formFunction?.current) {
                        const result = runSubListCommand(
                          form.current,
                          formFunction.current,
                          "roasting_greenbean_comb",
                          roasting_greenbean_fields,
                          e.index,
                          -1,
                          true,
                        );
                        setGreenbeanOrder();
                        checkSingleOrigin(form.current, "roasting_single_origin", result <= 1);
                        setTimeout(() => {
                          setGreenbeanInfo();
                          calGreenbeanMass();
                        }, dc.setTimeoutDelay / 2);
                      }
                    },
                    tooltip: "remove_label",
                  },
                  // roasting_greenbean_top: {
                  //   ...dc.buttonDefault("CaretDoubleUp", undefined, "default", undefined, "input_ml px-2 " + dc.mobileHidden),
                  //   read: { display: false },
                  //   saveData: false,
                  //   onClick: (e) => {
                  //     if (form?.current && formFunction?.current) {
                  //       runSubListCommand(form.current, formFunction.current, "roasting_greenbean_comb", roasting_greenbean_fields, e.index, 0);
                  //       setGreenbeanOrder();
                  //     }
                  //   },
                  //   tooltip: "top_label",
                  // },
                  roasting_greenbean_up: {
                    ...dc.buttonDefault("CaretUp", undefined, "default", undefined, "input_ml px-2 " + dc.mobileHidden),
                    read: { display: false },
                    saveData: false,
                    onClick: (e) => {
                      if (form?.current && formFunction?.current) {
                        runSubListCommand(
                          form.current,
                          formFunction.current,
                          "roasting_greenbean_comb",
                          roasting_greenbean_fields,
                          e.index,
                          e.index - 1,
                        );
                        setGreenbeanOrder();
                      }
                    },
                    tooltip: "up_label",
                  },
                  // roasting_greenbean_down: {
                  //   ...dc.buttonDefault("CaretDown", undefined, "default", undefined, "px-2 " + dc.mobileHidden),
                  //   read: { display: false },
                  //   saveData: false,
                  //   onClick: (e) => {
                  //     if (form?.current && formFunction?.current) {
                  //       runSubListCommand(
                  //         form.current,
                  //         formFunction.current,
                  //         "roasting_greenbean_comb",
                  //         roasting_greenbean_fields,
                  //         e.index,
                  //         e.index + 1,
                  //       );
                  //       setGreenbeanOrder();
                  //     }
                  //   },
                  //   tooltip: "down_label",
                  // },
                  // roasting_greenbean_bottom: {
                  //   ...dc.buttonDefault("CaretDoubleDown", undefined, "default", undefined, "px-2 " + dc.mobileHidden),
                  //   read: { display: false },
                  //   saveData: false,
                  //   onClick: (e) => {
                  //     if (form?.current && formFunction?.current) {
                  //       runSubListCommand(
                  //         form.current,
                  //         formFunction.current,
                  //         "roasting_greenbean_comb",
                  //         roasting_greenbean_fields,
                  //         e.index,
                  //         -1,
                  //       );
                  //       setGreenbeanOrder();
                  //     }
                  //   },
                  //   tooltip: "bottom_label",
                  // },
                  greenbean_name_insert: {
                    ...dc.buttonDefault("PencilSimpleLine", undefined, "default", undefined, "px-2 input_ml"),
                    read: { display: false },
                    saveData: false,
                    onClick: (e) => {
                      const result = runFormFunction(formFunction?.current, "greenbean_roaster_seq_" + e.index, "selectData");
                      // Debug(result);
                      if (form?.current && result.result) {
                        form.current.setFieldsValue({
                          roasting_name_locale: result.result["greenbean_name_locale"],
                          roasting_name: result.result["greenbean_name"],
                          roasting_nick_locale: result.result["greenbean_nick_locale"],
                          roasting_nick: result.result["greenbean_nick"],
                        });
                      }
                    },
                    tooltip: "name_insert_label",
                  },

                  greenbean_roaster_seq: {
                    ...roasting_greenbean,
                    tooltip: true,
                    tooltipTransition: false,
                    tooltipPlacement: "topLeft",
                    selectProp: { suffixIcon: "" },
                    readOnly: true,
                  },
                },
              },
              roasting_greenbean_comb_sub: {
                flexClassName: "ml-0 mt-2 lg:ml-2 lg:mt-0 ",
                fieldId: {
                  greenbean_mass: {
                    ...dc.mass,
                    inputClassName: dc.greenbeanMassWidth + dc.textLastClassName,
                    onChange: (e) => {
                      //Debug(e);
                      calGreenbeanMass();
                    },
                    //read: { inputClassName: dc.mass.inputClassName + " input-text-center", readOnly: true },
                  },
                  greenbean_percent: {
                    ...dc.percent,
                    tooltip: "ratio_label",
                    onChange: (e) => {
                      //Debug(e);
                      //calGreenbeanMass();
                    },
                  },
                  greenbean_order: {
                    ...dc.number,
                    inputClassName: "hidden",
                  },
                },
              },
            },
          },
          greenbean_total_mass: {
            ...dc.mass,
            inputClassName: dc.greenbeanMassWidth + dc.textLastClassName,
            placeholder: "greenbean_total_mass",
            tooltip: "greenbean_total_mass",
            tooltipPlacement: "left",
            label: "blank",
            labelClassName: dc.mobileHidden,
            readOnly: true,
            variant: "borderless",
            valueStyle: { justifyContent: "flex-end" },
            //read: { inputClassName: dc.mass.inputClassName + " input-text-center", readOnly: true },
            // inputClassName: dc.mass.inputClassName + " " + dc.inputCountryClassName
          },
          roasting_single_origin: {
            ...dc.use,
            disabled: true,
          },
          blending_create_use: {
            ...dc.use,
            read: { ...dc.use.read, display: "notNull", displayCheckIds: ["blending_create_seq"] },
            changePass: true,
          },
          blending_create_seq: {
            ...dc.selectSearch,
            read: { display: "notNull" },
            changePass: true,
            inputClassName: "w-full",
            widthFull: true,
            dataValueList: ["blending_default_list"],
            create: {
              dataProp: { firstReload: true },
            },
            edit: {
              dataUrl: "/api/roaster/blending/default/code",
            },
            dataLabel: {
              value: "blending_seq",
              label: [
                params?.locale === enLocale
                  ? { field: "blending_name", subs: "blending_nick" }
                  : { field: "blending_name_locale", subs: "blending_nick_locale" },
              ],
              labelSort: true,
            },
            // selectPropOption: { reloadButtonFront: true },
            // selectWithLoad: selectWithList,
            tooltip: true,
            tooltipTransition: false,
            tooltipPlacement: "topLeft",
          },
          div_3: dc.itemDiv,
          ...roasting_public_stage,
          roasting_profile_use: { ...dc.use, required: true, defaultValue: false },
          roasting_profile_default_temp: {
            label: "blank",
            labelClassName: dc.mobileHidden,
            fieldId: {
              pre_heating_end_bean: {
                ...dc.roastingTemp,
                placeholder: "pre_heating_end_label",
                tooltip: "pre_heating_end_label",
              },
              roasting_start_bean: {
                ...dc.roastingTemp,
                placeholder: "roasting_start_temp",
                tooltip: "roasting_start_temp",
              },
              roasting_dried_bean: { ...dc.roastingTemp, placeholder: "roasting_dried", tooltip: "roasting_dried" },
            },
            read: {
              display: "notNull",
              displayCheckIds: ["pre_heating_end_bean", "roasting_start_bean", "roasting_dried_bean"],
            },
          },
          roasting_profile_event_temp: {
            label: "blank",
            labelClassName: dc.mobileHidden,
            fieldId: {
              roasting_first_start_bean: {
                ...dc.roastingTemp,
                placeholder: "roasting_first_start",
                tooltip: "roasting_first_start",
              },
              roasting_second_start_bean: {
                ...dc.roastingTemp,
                placeholder: "roasting_second_start",
                tooltip: "roasting_second_start",
              },
              roasting_end_bean: { ...dc.roastingTemp, placeholder: "roasting_end_bean", tooltip: "roasting_end_bean" },
            },
            read: {
              display: "notNull",
              displayCheckIds: ["roasting_first_start_bean", "roasting_second_start_bean", "roasting_end_bean"],
            },
          },
          roasting_profile_check: {
            label: "blank",
            labelClassName: dc.mobileHidden,
            read: {
              display: "notNull",
              displayCheckIds: ["roasting_check_term", "roasting_check_until", "roasting_prediction_loss"],
            },
            fieldId: {
              roasting_check_term: {
                ...dc.select,
                placeholder: "check_term_label",
                tooltip: "check_term_label",
                unit: "term_second",
                inputClassName: dc.roastingTemp.inputClassName,
                valueList: [
                  { label: params?.locale === "ko" ? "30초" : "30s", value: 30 },
                  { label: params?.locale === "ko" ? "1분" : "1m", value: 60 },
                  { label: params?.locale === "ko" ? "2분" : "2m", value: 120 },
                ],
              },
              roasting_check_until: {
                ...dc.untilMinite,
                placeholder: "check_until_label",
                tooltip: "check_until_label",
                inputClassName: dc.roastingTemp.inputClassName,
              },
              roasting_prediction_loss: {
                ...dc.lossRate,
                tooltip: "roasting_prediction_loss",
                placeholder: "roasting_prediction_loss",
                inputClassName: dc.roastingTemp.inputClassName,
              },
            },
          },
          roasting_use: { ...dc.useDefault, required: true },
          //rgst_at:{...dc.},
          rgst_by: { ...dc.rgst },
          //edit_at:{...dc.},
          edit_by: { ...dc.edit },
        },
        tempValue: { ...dc.tempPublicStage },
        listColLinkField: "roasting_seq",
        listSearch: [
          {
            ...dc.grade,
            inputClassName: dc.searchSelectWidth,
            field: "search0",
            label: "roasting_grade_list",
            placeholder: "roasting_grade_list",
          },
          {
            ...dc.country,
            inputClassName: dc.searchSelectWidth,
            field: "search1",
            label: "roasting_country_list",
            placeholder: "roasting_country_list",
          },
          {
            ...dc.variety,
            codeGroup: "VRT",
            field: "search2",
            inputClassName: dc.searchSelectWidth,
            label: "roasting_variety_list",
            placeholder: "roasting_variety_list",
          },
        ],
        listSearchSelect: [
          {
            ...dc.input,
            field: "search_title_all",
            label: "roasting_name_locale",
            placeholder: "roasting_name_locale",
          },
          // { ...dc.input, field: "search_type0", label: "roasting_name_locale", placeholder: "roasting_name_locale" },
          // { ...dc.input, field: "search_type1", label: "roasting_name", placeholder: "roasting_name" },
        ],
        listOrder: [
          "roasting_name_locale_orderasc",
          "roasting_name_locale_orderdesc",
          // "roasting_name_orderdesc",
          // "roasting_name_orderasc",
          "roasting_country_list_orderasc",
          "roasting_country_list_orderdesc",
        ],
        listCols: [
          // "roaster_seq",
          // "roasting_seq",
          //"roasting_uuid",
          params?.locale === enLocale ? "roasting_name" : "roasting_name_locale",
          //"roasting_nick",
          //"roasting_nick_locale",
          //"roasting_machine_seq",
          //"roasting_user_seq",
          //"roasting_result_year_ref",
          //"roasting_result_seq_ref",
          //"roasting_single_origin",
          //"roasting_country_list",
          // "roasting_grade_list",
          //"roasting_grade_detail_list",
          // "roasting_variety_list",
          { field: "greenbean_total_mass", ...dc.mass },
          //"roasting_auth"
        ],
      };
    //로스팅결과 정보
    //--info--{
    //--info--"table":{"system_TABLE_SCHEMA":"clm_roaster","system_TABLE_NAME":"roasting_result","system_table_pk":["roaster_seq","roasting_result_year","roasting_result_seq"],"system_table_manual_increment":"roasting_result_seq","system_table_page":"RoastingResult","system_table_path":"roaster/roasting/result","system_table_page_name":"RoastingResult","system_table_auth":["SADMIN","ADMIN","USER"],"system_select_auth":["roaster"],"system_roaster_auth":"ROASTER","system_roaster_auth_field":["roasting_auth"],"system_table_mapper":"roasting","system_table_detail_result":"roasting_result","system_table_search_column":["roasting_result_year","roasting_result_date","roasting_batch_no"],"system_table_search_select":["roasting_name_locale","roasting_nick_locale"],"system_table_order_column":["roasting_result_year","roasting_result_date","roasting_batch_no"],"system_table_default_name_column":"roasting_name_locale","system_table_en_name_column":"roasting_name"}
    //--info--}

    //로스팅프로파일 정보
    //--info--{
    //--info--"table":{"system_TABLE_SCHEMA":"clm_roaster","system_TABLE_NAME":"roasting_result_profile","system_table_pk":["roaster_seq","roasting_result_year","roasting_result_seq"],"system_table_page":"RoastingResultProfile","system_table_path":"roaster/roasting/result/profile","system_table_page_name":"RoastingResultProfile","system_table_auth":["SADMIN","ADMIN","USER"],"system_select_auth":["roaster"],"system_roaster_auth":"ROASTER","system_roaster_auth_field":["roasting_auth"],"system_table_mapper":"roasting","system_table_detail_result":"roasting_result_profile"}
    //--info--}

    //로스팅결과생두 정보
    //--info--{
    //--info--"table":{"system_TABLE_SCHEMA":"clm_roaster","system_TABLE_NAME":"roasting_result_greenbean","system_table_pk":["roaster_seq","roasting_result_year","roasting_result_seq","greenbean_year","greenbean_roaster_seq"],"system_table_page":"RoastingResultGreenbean","system_table_path":"roaster/roasting/result/greenbean","system_table_page_name":"RoastingResultGreenbean","system_table_auth":["SADMIN","ADMIN","USER"],"system_select_auth":["roaster"],"system_roaster_auth":"ROASTER","system_roaster_auth_field":["roasting_auth"],"system_table_mapper":"roasting","system_table_detail_result":"roasting_result"}
    //--info--}

    case "RoastingResult":
      return {
        ...result,
        dataFetch: {
          fetchUrl: "/api/roaster/roasting/result/detail/",
          saveFetch: { fetchUrl: "/api/roaster/roasting/result/edit" },
        },
        listFetch: { fetchUrl: "/api/roaster/roasting/result/list" },
        dataResultName: "roasting_result",
        dataName: "RoastingResultData",
        // dataScrollAnimate: false,
        timer: [roastingIndexKeyStr, ...roastingTimerList],
        checkDataMode: true,
        dataInit: ResultInit,
        dataInitDelay: 300,
        resetClassList: false,
        dataFormClassDefault: ["hidden_roasting_check"],
        dataMerge: "roasting_result_profile",
        dataScrollAnimate: false,
        clipboard: roastingProfileClipboard,
        dataCols: {
          roasting_seq: {
            label: "roasting_select_label",
            ...dc.selectSearch,
            labelClassName: dc.strongLabelClassName,
            inputClassName: "w-full",
            dataUrl: "/api/roaster/roasting/default/code",
            dataProp: {
              load: (data, select_data) => {
                const roasting_seq = form?.current?.getFieldValue("roasting_seq");
                const { run, result } = runFormFunction(formFunction?.current, "roasting_greenbean_comb", "getCount");
                Debug(roasting_seq, result);
                if ((roasting_seq !== undefined && result === 0) || result === undefined) {
                  setTimeout(() => {
                    setRoastingSeq();
                  }, dc.setTimeoutDelay / 2);
                }
                //Debug(data, select_data);
              },
            },
            widthFull: true,
            dataLabel: {
              value: "roasting_seq",
              label: [
                params?.locale === enLocale
                  ? { field: "roasting_name", subs: "roasting_nick" }
                  : { field: "roasting_name_locale", subs: "roasting_nick_locale" },
              ],
              labelSort: true,
            },
            // selectPropOption: { reloadButtonFront: true },
            // selectWithLoad: selectWithList,
            onChange: (e) => {
              setRoastingSeq();
            },
            // onPressEnter: (e) => {
            //   //addGreenbeanList(false);
            // },
            tooltip: true,
            tooltipTransition: false,
          },
          ...roasting_names,
          roasting_machine_seq: roasting_machine_seq,
          roasting_result_year: { ...dc.year, update: { disabled: true }, required: true },
          roasting_result_seq: dc.hidden,
          roasting_result_date: {
            ...dc.date,
            changePass: true,
            update: { disabled: true },
            required: true,
            onChange: (e) => {
              if (form?.current) {
                form.current.setFieldsValue({ roasting_result_year: e.value });
              }
            },
          },
          // greenbean_total_mass: {
          //   ...dc.mass,
          //   placeholder: "greenbean_total_mass",
          //   tooltip: "greenbean_total_mass",
          //   tooltipPlacement: "left",
          //   label: "blank",
          //   readOnly: true,
          //   variant: "borderless",
          //   valueStyle: { justifyContent: "flex-end" },
          //   //read: { inputClassName: dc.mass.inputClassName + " input-text-center", readOnly: true },
          //   // inputClassName: dc.mass.inputClassName + " " + dc.inputCountryClassName
          // },

          //green_bean_detail: dc.input,
          roasting_batch_auto: {
            ...dc.use,
          },
          roasting_batch_no: { ...dc.number, inputClassName: dc.inputNumberClassName, minValue: 1 },
          roasting_instock: {
            ...dc.use,
            label: "instock_label",
            labelClassName: dc.strongLabelClassName,
          },
          div_1: dc.itemDiv,
          roasting_greenbean_comb_explain: {
            label: "blank",
            labelClassName: dc.mobileHidden,
            valueClassName: "flex-col lg:flex-row mobile_multi",
            fieldId: {
              roasting_greenbean_comb_explain_main: {
                flexClassName: "w-full flex-row",
                fieldId: {
                  roasting_greenbean_remove_explain: {
                    ...dc.buttonDefault("Minus", undefined, "default", undefined, "px-2 invisible"),
                    read: { display: false },
                    saveData: false,
                    onClick: (e) => {},
                  },
                  roasting_greenbean_name_insert_explain: {
                    ...dc.buttonDefault("PencilSimpleLine", undefined, "default", undefined, "px-2 invisible"),
                    read: { display: false },
                    saveData: false,
                    onClick: (e) => {},
                  },
                  roasting_greenbean_seq_explain: {
                    ...dc.inputFull,
                    placeholder: "roasting_greenbean_explain",
                    saveData: false,
                    allowClear: false,
                    inputClassName: "text-center",
                    disabled: true,
                    readOnly: true,
                    variant: "borderless",
                    noItem: true,
                  },
                },
              },
              roasting_greenbean_comb_explain_sub: {
                flexClassName: "ml-0 mt-2 lg:ml-2 lg:mt-0 " + dc.mobileHidden,
                fieldId: {
                  roasting_greenbean_year_explain: {
                    ...dc.number,
                    placeholder: "greenbean_year",
                    saveData: false,
                    allowClear: false,
                    inputClassName: dc.selectYearWidth + " input-text-center",
                    disabled: true,
                    readOnly: true,
                    variant: "borderless",
                    noItem: true,
                  },
                  roasting_greenbean_mass_explain: {
                    ...dc.number,
                    placeholder: "greenbean_mass",
                    saveData: false,
                    allowClear: false,
                    inputClassName: dc.greenbeanMassWidth + " input-text-center",
                    disabled: true,
                    readOnly: true,
                    variant: "borderless",
                    noItem: true,
                  },
                  roasting_greenbean_moisture_explain: {
                    ...dc.number,
                    placeholder: "moisture",
                    saveData: false,
                    allowClear: false,
                    inputClassName: dc.greenbeanNumberWidth + " input-text-center",
                    disabled: true,
                    readOnly: true,
                    variant: "borderless",
                    noItem: true,
                  },
                  roasting_greenbean_percent_explain: {
                    ...dc.number,
                    placeholder: "ratio_label",
                    saveData: false,
                    allowClear: false,
                    inputClassName: dc.greenbeanNumberWidth + " input-text-center",
                    disabled: true,
                    readOnly: true,
                    variant: "borderless",
                    noItem: true,
                  },
                },
              },
            },
          },
          roasting_greenbean_list: {
            labelClassName: dc.mobileHidden,
            read: { itemClassName: "hidden" },
            valueClassName: "flex-col lg:flex-row mobile_multi",
            fieldId: {
              roasting_greenbean_list_main: {
                flexClassName: "w-full flex-row",
                fieldId: {
                  roasting_greenbean_add: {
                    ...dc.buttonDefault(
                      "Plus",
                      () => {
                        addGreenbeanList(false);
                      },
                      "default",
                    ),
                    tooltip: "add_label",
                  },
                  roasting_greenbean_reload: {
                    ...dc.buttonDefault(
                      "ArrowClockwise",
                      () => {
                        runFormFunction(formFunction?.current, "roasting_greenbean_seq", "reload", true);
                        runFormFunction(formFunction?.current, "roasting_greenbean_year", "reload", true);
                      },
                      "default",
                      undefined,
                      "px-2 input_ml",
                    ),
                    tooltip: "reload_label",
                  },

                  roasting_greenbean_seq: {
                    ...dc.selectSearch,
                    inputClassName: dc.greenbeanSeqWidth,
                    dataUrl: "/api/roaster/greenbean/default/code",
                    dataProp: {
                      // load: (data, select_data) => {
                      //   Debug(data, select_data);
                      // },
                    },
                    create: { dataProp: { firstReload: true } },
                    widthFull: true,
                    dataLabel: {
                      value: "greenbean_roaster_seq",
                      label: [
                        params?.locale === enLocale
                          ? { field: "greenbean_name", subs: "greenbean_nick" }
                          : { field: "greenbean_name_locale", subs: "greenbean_nick_locale" },
                      ],
                      labelSort: true,
                    },
                    selectPropOption: { reloadButton: false },
                    selectWithLoad: seqSelectWithList,
                    selectChangeLoad: "roasting_greenbean_year",
                    onChange: (data) => {},
                    onPressEnter: (e) => {
                      addGreenbeanList(false);
                    },
                    tooltip: true,
                    tooltipTransition: false,
                    saveData: false,
                  },
                },
              },
              roasting_greenbean_list_sub: {
                flexClassName: "ml-0 mt-2 lg:ml-2 lg:mt-0 ",
                fieldId: {
                  roasting_greenbean_year: {
                    ...dc.select,
                    inputClassName: dc.selectYearWidth + " input-text-center",
                    dataValueList: ["roasting_result_greenbean", "greenbean_instock_list"],
                    create: {
                      dataUrl: "/api/roaster/greenbean/year/code",
                      // dataProp: {
                      //   load: (data, select_data) => {
                      //     Debug(data, select_data);
                      //   },
                      //   firstReload: true,
                      // },
                    },
                    dataProp: {
                      load: (data, select_data, field, index, change) => {
                        //Debug(data, select_data);
                        if (form?.current && select_data) {
                          const moisture = getMoistureAvg(select_data);
                          if (moisture && form.current.getFieldValue("roasting_greenbean_moisture") === undefined) {
                            form.current.setFieldValue("roasting_greenbean_moisture", moisture);
                          }
                        }
                      },
                    },
                    dataLabel: {
                      value: "greenbean_year",
                      label: ["greenbean_year"],
                      labelSort: -1,
                    },
                    selectFieldFilter: { greenbean_roaster_seq: "roasting_greenbean_seq" },
                    selectFieldRequired: "roasting_greenbean_seq",
                    selectPropOption: { reloadButton: false, setEmptyValue: 0 },
                    selectWithLoad: yearSelectWithList,
                    onChange: (data) => {
                      const temp_result = runFormFunction(formFunction?.current, "roasting_greenbean_year", "selectData");
                      if (form?.current && temp_result.result) {
                        const moisture = getMoistureAvg(temp_result.result);
                        if (moisture) {
                          form.current.setFieldValue("roasting_greenbean_moisture", moisture);
                        }
                      }
                    },
                    // onPressEnter: (e) => {
                    //   addGreenbeanList(false);
                    // },
                    placeholder: "year_select",
                    saveData: false,
                  },
                  roasting_greenbean_mass: {
                    ...dc.mass,
                    inputClassName: dc.greenbeanMassWidth + dc.textLastClassName,
                    saveData: false,
                    placeholder: "greenbean_mass",
                    onPressEnter: (e) => {
                      addGreenbeanList(false);
                    },

                    // inputClassName: dc.mass.inputClassName + " " + dc.inputCountryClassName
                  },
                  roasting_greenbean_moisture: {
                    ...dc.moisture,
                    inputClassName: dc.greenbeanNumberWidth + dc.textLastClassName,
                    onPressEnter: (e) => {
                      addGreenbeanList(false);
                    },
                  },
                  roasting_greenbean_percent: {
                    ...dc.percent,
                    inputClassName: dc.greenbeanNumberWidth + dc.textLastClassName,
                    saveData: false,
                    placeholder: "ratio_label",
                    onPressEnter: (e) => {
                      addGreenbeanList();
                    },
                    // inputClassName: dc.mass.inputClassName + " " + dc.inputCountryClassName
                  },
                },
              },
            },
          },
          div_2: { ...dc.itemDiv, read: { itemClassName: "hidden" } },
          roasting_greenbean_comb: {
            //labelClassName: "justify-center",
            label: "roasting_greenbean_count",
            // labelInput: {
            //   fieldId: "greenbean_percent",
            //   ...dc.percent,
            //   tooltip: "ratio_label",
            //   onChange: (e) => {
            //     //Debug(e);
            //     //calGreenbeanMass(true);
            //   },
            // },
            // labelMyAuto: false,
            //inputType: "display",
            // subListEmptyLabel: "empty",
            // subListEmptyValue: <div className="w-full text-center">{t("roasting_greenbean_list_empty")}</div>,
            subList: { target: "roasting_result_greenbean", labelField: "COLUMN_NAME" },
            subListKeys: ["greenbean_year", "greenbean_roaster_seq"],
            minLength: 1,

            labelClassName: dc.mobileHidden,
            valueClassName: "flex-col lg:flex-row mobile_multi",
            fieldId: {
              roasting_greenbean_comb_main: {
                flexClassName: "w-full flex-row",
                fieldId: {
                  greenbean_remove: {
                    ...dc.buttonDefault("Minus", undefined, "default"),
                    read: { display: false },
                    saveData: false,
                    onClick: (e) => {
                      //Debug(e);
                      if (form?.current && formFunction?.current) {
                        const result = runSubListCommand(
                          form.current,
                          formFunction.current,
                          "roasting_greenbean_comb",
                          roasting_greenbean_fields,
                          e.index,
                          -1,
                          true,
                        );
                        calGreenbeanMass(true);
                        setGreenbeanOrder();
                        checkSingleOrigin(form.current, "roasting_single_origin", result <= 1);
                        setTimeout(() => {
                          setGreenbeanInfo();
                        }, dc.setTimeoutDelay / 2);
                      }
                    },
                    tooltip: "remove_label",
                  },
                  // roasting_greenbean_top: {
                  //   ...dc.buttonDefault("CaretDoubleUp", undefined, "default", undefined, "input_ml px-2 " + dc.mobileHidden),
                  //   read: { display: false },
                  //   saveData: false,
                  //   onClick: (e) => {
                  //     if (form?.current && formFunction?.current) {
                  //       runSubListCommand(form.current, formFunction.current, "roasting_greenbean_comb", roasting_greenbean_fields, e.index, 0);
                  //       setGreenbeanOrder();
                  //     }
                  //   },
                  //   tooltip: "top_label",
                  // },
                  roasting_greenbean_up: {
                    ...dc.buttonDefault("CaretUp", undefined, "default", undefined, "input_ml px-2 " + dc.mobileHidden),
                    read: { display: false },
                    saveData: false,
                    onClick: (e) => {
                      if (form?.current && formFunction?.current) {
                        runSubListCommand(
                          form.current,
                          formFunction.current,
                          "roasting_greenbean_comb",
                          roasting_greenbean_fields,
                          e.index,
                          e.index - 1,
                        );
                        setGreenbeanOrder();
                      }
                    },
                    tooltip: "up_label",
                  },
                  // roasting_greenbean_down: {
                  //   ...dc.buttonDefault("CaretDown", undefined, "default", undefined, "px-2 " + dc.mobileHidden),
                  //   read: { display: false },
                  //   saveData: false,
                  //   onClick: (e) => {
                  //     if (form?.current && formFunction?.current) {
                  //       runSubListCommand(
                  //         form.current,
                  //         formFunction.current,
                  //         "roasting_greenbean_comb",
                  //         roasting_greenbean_fields,
                  //         e.index,
                  //         e.index + 1,
                  //       );
                  //       setGreenbeanOrder();
                  //     }
                  //   },
                  //   tooltip: "down_label",
                  // },
                  // roasting_greenbean_bottom: {
                  //   ...dc.buttonDefault("CaretDoubleDown", undefined, "default", undefined, "px-2 " + dc.mobileHidden),
                  //   read: { display: false },
                  //   saveData: false,
                  //   onClick: (e) => {
                  //     if (form?.current && formFunction?.current) {
                  //       runSubListCommand(
                  //         form.current,
                  //         formFunction.current,
                  //         "roasting_greenbean_comb",
                  //         roasting_greenbean_fields,
                  //         e.index,
                  //         -1,
                  //       );
                  //       setGreenbeanOrder();
                  //     }
                  //   },
                  //   tooltip: "bottom_label",
                  // },
                  // greenbean_name_insert: {
                  //   ...dc.buttonDefault("PencilSimpleLine", undefined, "default", undefined, "px-2 input_ml"),
                  //   read: { display: false },
                  //   saveData: false,
                  //   onClick: (e) => {
                  //     const result = runFormFunction(formFunction?.current, "greenbean_roaster_seq_" + e.index, "selectData");
                  //     Debug(result);
                  //     if (form?.current && result.result) {
                  //       form.current.setFieldsValue({
                  //         roasting_name_locale: result.result["greenbean_name_locale"],
                  //         roasting_name: result.result["greenbean_name"],
                  //         roasting_nick_locale: result.result["greenbean_nick_locale"],
                  //         roasting_nick: result.result["greenbean_nick"],
                  //       });
                  //     }
                  //   },
                  //   tooltip: "name_insert_label",
                  // },

                  greenbean_roaster_seq: {
                    ...roasting_greenbean,
                    tooltip: true,
                    tooltipTransition: false,
                    tooltipPlacement: "topLeft",
                    selectProp: { suffixIcon: "" },
                    selectWithLoad: "greenbean_year",
                    readOnly: true,
                  },
                },
              },
              roasting_greenbean_comb_sub: {
                flexClassName: "ml-0 mt-2 lg:ml-2 lg:mt-0 ",
                fieldId: {
                  greenbean_year: {
                    ...dc.select,
                    inputClassName: dc.selectYearWidth,
                    read: { inputClassName: dc.selectYearWidth + " text-center", readOnly: true },
                    dataValueList: ["roasting_result_greenbean", "greenbean_instock_list"],
                    create: {
                      dataUrl: "/api/roaster/greenbean/year/code",
                      dataProp: {
                        // load: (data, select_data) => {
                        //   Debug(data, select_data);
                        // },
                        // firstReload: true,
                      },
                    },
                    dataLabel: {
                      value: "greenbean_year",
                      label: ["greenbean_year"],
                      labelSort: -1,
                    },
                    selectFieldFilter: { greenbean_roaster_seq: "greenbean_roaster_seq" },
                    selectFieldRequired: "greenbean_roaster_seq",
                    selectPropOption: { reloadButton: false, setEmptyValue: 0 },
                    placeholder: "year_select",
                    onChange: (data) => {
                      const temp_result = runFormFunction(formFunction?.current, "greenbean_year_" + data.index, "selectData");
                      if (form?.current && temp_result.result) {
                        // Debug(temp_result.result);
                        const moisture = getMoistureAvg(temp_result.result);
                        if (moisture) {
                          form.current.setFieldValue("greenbean_moisture_" + data.index, moisture);
                          calGreenbeanMass(true);
                        }
                      }
                    },
                    // onPressEnter: (e) => {
                    //   addGreenbeanList(false);
                    // },
                  },
                  greenbean_mass: {
                    ...dc.mass,
                    inputClassName: dc.greenbeanMassWidth + dc.textLastClassName,
                    onChange: (e) => {
                      //Debug(e);
                      calGreenbeanMass(true);
                    },
                    //read: { inputClassName: dc.mass.inputClassName + " input-text-center", readOnly: true },
                  },
                  greenbean_moisture: {
                    ...dc.moisture,
                    inputClassName: dc.greenbeanNumberWidth + dc.textLastClassName,
                    onChange: (e) => {
                      //Debug(e);
                      calGreenbeanMass(true);
                    },
                  },
                  greenbean_percent: {
                    ...dc.percent,
                    inputClassName: dc.greenbeanNumberWidth + dc.textLastClassName,
                    tooltip: "ratio_label",
                    onChange: (e) => {
                      //Debug(e);
                      //calGreenbeanMass(true);
                    },
                  },
                  greenbean_order: {
                    ...dc.number,
                    inputClassName: "hidden",
                  },
                },
              },
            },
          },
          div_3: dc.itemDiv,
          greenbean_country_map: {
            ...dc.geoMapCountryChart("greenbean_country_list", true),
          },
          greenbean_country_list: {
            ...dc.geoMapCountryList(formFunction?.current, "greenbean_country_map", params?.locale, true),
            selectFilter: "CFPRDC",
            label: "greenbean_country_code",
          },
          greenbean_grade_list: { ...dc.grade, selectProp: { mode: "multiple" } },
          greenbean_grade_detail_list: { ...dc.gradeDetail, selectProp: { mode: "multiple" } },
          greenbean_variety_list: {
            ...dc.varietyMulti,
            selectProp: { mode: "multiple" },
            inputDirect: { target: "greenbean_variety_etc", query: ".greenbean_variety_etc_item" },
            read: {
              onClick: dc.clickDefault(
                (e: any) => {
                  //alert(e);
                },
                () => {
                  //alert("해당 품종에 대한 정보가 없습니다.");
                },
              ),
            },
          },
          greenbean_variety_etc: {
            ...dc.inputFull,
            itemClassName: "greenbean_variety_etc_item",
            minLength: 3,
            maxLength: 300,
            showCount: true,
            label: "blank",
            labelClassName: dc.mobileHidden,
            placeholder: "greenbean_variety_list",
          },
          greenbean_process_list: {
            ...dc.process,
            label: "greenbean_process",
            selectProp: { mode: "multiple" },
            inputDirect: { target: "greenbean_process_etc", query: ".greenbean_process_etc_item" },
          },
          greenbean_process_etc: {
            ...dc.inputFull,
            itemClassName: "greenbean_process_etc_item",
            minLength: 3,
            maxLength: 300,
            showCount: true,
            label: "blank",
            labelClassName: dc.mobileHidden,
            placeholder: "greenbean_process",
          },
          roasting_single_origin: {
            ...dc.use,
            changePass: true,
            //disabled: true,
          },
          blending_create_use: {
            ...dc.use,
            read: { ...dc.use.read, display: "notNull", displayCheckIds: ["blending_create_seq"] },
            changePass: true,
          },
          blending_create_seq: {
            ...dc.selectSearch,
            read: { display: "notNull" },
            changePass: true,
            inputClassName: "w-full",
            dataValueList: ["blending_default_list"],
            create: {
              dataProp: { firstReload: true },
            },
            edit: {
              dataUrl: "/api/roaster/blending/default/code",
            },
            widthFull: true,
            dataLabel: {
              value: "blending_seq",
              label: [
                params?.locale === enLocale
                  ? { field: "blending_name", subs: "blending_nick" }
                  : { field: "blending_name_locale", subs: "blending_nick_locale" },
              ],
              labelSort: true,
            },
            // selectPropOption: { reloadButtonFront: true },
            // selectWithLoad: selectWithList,
            tooltip: true,
            tooltipTransition: false,
          },
          div_4: {
            ...dc.itemDiv,
            read: {
              display: "notNull",
              displayCheckIds: [
                "outside_air",
                "outside_hum",
                "outside_hpa",
                "inside_air",
                "inside_hum",
                "inside_hpa",
                "inside2_air",
                "inside2_hum",
                "inside2_dist",
                "inside3_air",
                "inside3_hum",
                "inside3_dist",
              ],
            },
          },

          condition: {
            label: "blank",
            labelClassName: dc.mobileHidden,
            read: {
              display: "notNull",
              displayCheckIds: [
                "outside_air",
                "outside_hum",
                "outside_hpa",
                "inside_air",
                "inside_hum",
                "inside_hpa",
                "inside2_air",
                "inside2_hum",
                "inside2_dist",
                "inside3_air",
                "inside3_hum",
                "inside3_dist",
              ],
            },
            fieldId: {
              condition_air: { ...dc.airTemp, readOnly: true, disabled: true, variant: "borderless", unit: "" },
              condition_hum: { ...dc.hum, readOnly: true, disabled: true, variant: "borderless", unit: "" },
              condition_hPa: { ...dc.hPa, readOnly: true, disabled: true, variant: "borderless", unit: "" },
            },
          },
          outside: {
            edit: { label: dc.weatherButton(form, "inside_hpa") },
            read: { display: "notNull", displayCheckIds: ["outside_air", "outside_hum", "outside_hpa"] },
            fieldId: {
              outside_air: dc.airTemp,
              outside_hum: dc.hum,
              outside_hpa: dc.hPa,
            },
          },
          inside1: {
            read: { display: "notNull", displayCheckIds: ["inside_air", "inside_hum", "inside_hpa"] },
            fieldId: {
              inside_air: dc.airTemp,
              inside_hum: dc.hum,
              inside_hpa: dc.hPa,
            },
          },
          inside2: {
            read: { display: "notNull", displayCheckIds: ["inside2_air", "inside2_hum", "inside2_dist"] },
            fieldId: {
              inside2_air: dc.airTemp,
              inside2_hum: dc.hum,
              inside2_dist: dc.distance,
            },
          },
          inside3: {
            read: { display: "notNull", displayCheckIds: ["inside3_air", "inside3_hum", "inside3_dist"] },
            fieldId: {
              inside3_air: dc.airTemp,
              inside3_hum: dc.hum,
              inside3_dist: dc.distance,
            },
          },
          div_5: {
            ...dc.itemDiv,
            read: {
              display: "notNull",
              displayCheckIds: [
                "public_stage_roaster",
                "public_stage_cafe",
                "public_stage_customer",
                "public_stage_normal",
                "roasting_auth",
              ],
            },
          },
          ...roasting_public_stage,
          div_6: dc.itemDiv,
          roasting_profile_use: {
            ...dc.use,
            required: true,
            changePass: true,
            defaultValue: false,
            onChange: (e) => {
              // Debug(e);
              setRoastingProfileUse();
            },
            read: { display: false },
          },
          ...roastingProfileCols(
            form,
            formFunction?.current,
            formMemo?.current,
            dataFunction?.current,
            params?.locale,
            params?.setTimer,
            t,
            message,
            props.isMobile,
          ),
          div_7: dc.itemDiv,
          status_explain: {
            label: "blank",
            labelClassName: dc.mobileHidden,
            fieldId: {
              explain_mass: { ...dc.mass, readOnly: true, disabled: true, variant: "borderless", unit: "" },
              explain_moisture: {
                ...dc.moisture,
                readOnly: true,
                disabled: true,
                variant: "borderless",
                unit: "",
                read: { display: "notNull", displayCheckIds: ["greenbean_moisture", "roasting_moisture"] },
              },
              explain_agtron: {
                ...dc.moisture,
                readOnly: true,
                disabled: true,
                variant: "borderless",
                unit: "",
                unitPrev: "",
                placeholder: "agtron",
                read: { display: "notNull", displayCheckIds: ["greenbean_agtron", "roasting_agtron"] },
              },
            },
          },
          greenbean_status: {
            fieldId: {
              greenbean_total_mass: {
                ...dc.mass,
                noItem: false,
                onChange: calcRoastingLoss,
              },
              greenbean_moisture: { ...dc.moisture, onChange: calcRoastingLoss, read: { display: "notNull" } },
              greenbean_agtron: { ...dc.agtron, read: { display: "notNull" } },
            },
          },
          roasting_status: {
            fieldId: {
              roasting_mass: {
                ...dc.mass,
                noItem: false,
                onChange: calcRoastingLoss,
              },
              roasting_moisture: { ...dc.moisture, onChange: calcRoastingLoss, read: { display: "notNull" } },
              roasting_agtron: { ...dc.agtron, read: { display: "notNull" } },
            },
          },
          roasting_calc: {
            labelClassName: dc.strongLabelClassName,
            fieldId: {
              roasting_loss: {
                ...dc.lossRate,
                disabled: true,
                readOnly: true,
                variant: "borderless",
                tooltip: "loss_rate",
              }, //, variant: "borderless"
              roasting_organic_loss: {
                ...dc.lossRate,
                inputClassName: dc.inputNumberClassName,
                placeholder: "organic_loss",
                disabled: true,
                readOnly: true,
                variant: "borderless",
                tooltip: "organic_loss",
                read: {
                  display: "notNullAnd",
                  displayCheckIds: ["greenbean_moisture", "roasting_moisture"],
                },
              }, //, variant: "borderless"
              roasting_mass_calc: {
                ...dc.mass,
                inputClassName: "input-padding-0 w-[3.5rem] text-last input-text-last pr-[1px]",
                spaceClassName: "w-[8rem] text-last",
                noItem: false,
                disabled: true,
                readOnly: true,
                variant: "borderless",
                unit: undefined,
                next: {
                  element: (
                    <strong>
                      /
                      <input
                        id="roasting_mass_calc_base"
                        type="number"
                        defaultValue={150}
                        disabled={false}
                        readOnly={false}
                        className="w-[3.5rem] text-sm py-[5px]"
                        onChange={() => {
                          const baseNo = Number((document.getElementById("roasting_mass_calc_base") as HTMLInputElement).value);
                          const base = isNaN(baseNo) ? 1 : baseNo;
                          Debug("onChange", base);
                          calcFieldsValue(form?.current, "roasting_mass", "/", "greenbean_total_mass", "roasting_mass_calc", 1, base);
                        }}
                      />
                    </strong>
                  ),
                  elementType: "element",
                },
              },
            },
          },
          div_8: { ...dc.itemDiv, read: { display: "notNull", displayCheckIds: ["roasting_result_memo"] } },
          // roasting_result_detail: dc.input,
          roasting_result_memo: {
            ...dc.textAreaM,
          },
          div_summary: {
            ...dc.itemDiv,
            // edit: { display: false },
            read: { display: "notNull" },
            displayCheckIds: ["roasting_end_term"],
          },
          roasting_summary: {
            label: "summary_label",
            labelClassName: dc.strongLabelClassName,
            inputType: "summary",
            // edit: { display: false },
            read: { display: "notNull" },
            edit: {
              labelNext: {
                element: <Icon iconName="ArrowCounterClockwise" iconType="" />,
                elementType: "button",
                transition: true,
                buttonProp: {
                  type: "text",
                  shape: "circle",
                  className: "ml-1 w-[1.5rem] h-[1.5rem] !min-w-[1.5rem]",
                  onClick: () => {
                    summaryRefresh(t, form?.current, formFunction?.current, formMemo?.current, dataFunction?.current, params?.locale);
                  },
                },
              },
            },
            displayCheckIds: ["roasting_end_term"],
            fieldId: { ...roastingSummaryFieldIdExp(" | ") },
            valueClassName: "DisplayValue",
            valueJoin: "",
          },
          roasting_prediction: {
            itemClassName: dc.roastingProfileClassName,
            read: { display: false },
            valueClassName: "flex-col lg:flex-row mobile_multi",
            fieldId: {
              roasting_prediction_main: {
                fieldId: {
                  roasting_prediction_term: {
                    ...dc.roastingTerm,
                    timeProp: {
                      ...dc.roastingTerm.timeProp,
                      nowButtonClick: (e: any) => {},
                    },
                    placeholder: "roasting_prediction_term",
                    readOnly: true,
                    saveData: false,
                  },
                  roasting_prediction_bean: {
                    ...dc.roastingTemp,
                    placeholder: "roasting_prediction_bean",
                    inputClassName: dc.roastingTemp.inputClassName + " " + dc.roastingProfileClassName,
                    readOnly: true,
                    saveData: false,
                  },
                },
              },
              roasting_prediction_sub: {
                flexClassName: "ml-0 mt-2 lg:ml-2 lg:mt-0 ",
                fieldId: {
                  roasting_prediction_loss: {
                    ...dc.lossRate,
                    tooltip: "roasting_prediction_loss",
                    placeholder: "roasting_prediction_loss",
                    inputClassName: dc.roastingTemp.inputClassName + " " + dc.roastingProfileClassName,
                    saveData: false,
                  },
                  roasting_prediction_change: {
                    ...dc.use,
                    inputClassName: dc.roastingProfileClassName,
                    defaultValue: false,
                    saveData: false,
                  },
                },
              },
            },
          },
          roasting_prediction_result: {
            // label: "prediction_result_label",
            itemClassName: dc.roastingProfileClassName,
            valueClassName: "whitespace-pre-wrap text-start DisplayValue",
            inputType: "display",
            display: false,
            read: { display: false },
            saveData: false,
          },
          div_compare_diff: {
            ...dc.itemDiv,
            itemClassName: dc.itemDiv.itemClassName + " " + dc.compareItemClassName,
          },
          roasting_compare_diff: {
            label: "diff_label",
            itemClassName: dc.compareItemClassName,
            valueClassName: "whitespace-pre-wrap text-start DisplayValue",
            inputType: "display",
            saveData: false,
          },
          div_compare_summary: {
            ...dc.itemDiv,
            itemClassName: dc.itemDiv.itemClassName + " " + dc.compareItemClassName,
          },
          roasting_compare_chart: {
            label: "display_label",
            labelClassName: dc.strongLabelClassName,
            itemClassName: dc.compareItemClassName,
            ...dc.selectMulti,
            widthFull: true,
            inputClassName: "w-full",
            variant: "outlined",
            onChange: (e) => {
              Debug(e);
              const values = e.value as string[];
              const timeline_chart = formMemo?.current["timeline_chart"];
              const compare_select = form?.current?.getFieldValue("roasting_compare_select");
              if (timeline_chart && timeline_chart.tempData) {
                Object.keys(timeline_chart.tempData).map((id) => {
                  timeline_chart.tempData[id].compare = id === compare_select || values.includes(id);
                });
              }
              const setValues: Record<string, any> = { timeline_chart: true };
              form?.current?.setFieldsValue(setValues);
              // setTimeout(() => {
              //   // if (!values.includes(compare_select)) {
              //   //   const change_list = [...values, compare_select].filter((item) => !checkEmpty(item));
              //   //   setValues["roasting_compare_chart"] = change_list.length > 0 ? change_list : undefined;
              //   // }
              // }, dc.setTimeoutShort);
            },
            noItem: false,
            readInput: true,
            readInputDisabled: false,
            saveData: false,
          },

          roasting_compare_select: {
            label: "roasting_compare",
            labelClassName: dc.strongLabelClassName,
            itemClassName: dc.compareItemClassName,
            widthFull: true,
            inputClassName: "w-full",
            inputType: "select",
            variant: "outlined",
            onChange: (e) => {
              Debug(e);
              summaryRefresh(t, form?.current, formFunction?.current, formMemo?.current, dataFunction?.current, params?.locale, e.value);
            },
            noItem: false,
            readInput: true,
            readInputDisabled: false,
            saveData: false,
          },
          roasting_compare_point_set: {
            label: "roasting_compare_point",
            itemClassName: dc.compareItemClassName,
            fieldId: {
              roasting_compare_point: {
                inputClassName: dc.inputNumberClassName,
                inputType: "select",
                variant: "outlined",
                defaultValue: "roasting_start_time",
                inputDirect: { target: "roasting_compare_point_direct", query: ".roasting_compare_point_direct" },
                valueList: [
                  {
                    label: t("roasting_start_time"),
                    value: "roasting_start_time",
                  },
                  {
                    label: t("roasting_turning_term"),
                    value: "roasting_turning_term",
                  },
                  {
                    label: t("roasting_dried_term"),
                    value: "roasting_dried_term",
                  },
                  {
                    label: t("roasting_first_start_term"),
                    value: "roasting_first_start_term",
                  },
                  // {
                  //   label: t("roasting_first_end_term"),
                  //   value: "roasting_first_end_term",
                  // },
                  {
                    label: t("roasting_second_start_term"),
                    value: "roasting_second_start_term",
                  },
                  // {
                  //   label: t("roasting_second_end_term"),
                  //   value: "roasting_second_end_term",
                  // },
                  {
                    label: t("roasting_end_term"),
                    value: "roasting_end_term",
                  },
                ],
                onChange: (e) => {
                  Debug(e);
                  timelineChartChange(form?.current, e);
                },
                noItem: false,
                readInput: true,
                readInputDisabled: false,
                saveData: false,
              },
              roasting_compare_point_direct: {
                ...dc.number,
                variant: "outlined",
                valueClassName: "roasting_compare_point_direct",
                inputClassName: dc.inputNumberClassName,
                onChange: (e) => {
                  timelineChartChange(form?.current, e);
                },
                unit: "s",
                noItem: false,
                readInput: true,
                readInputDisabled: false,
                saveData: false,
              },
            },
          },
          roasting_compare_summary: {
            label: "blank",
            itemClassName: dc.compareItemClassName,
            valueClassName: "DisplayValue whitespace-pre-wrap text-start",
            // valueClassName: "DisplayValue",
            maxLength: undefined,
            inputType: "display",
            saveData: false,
          },
          roasting_compare_memo: {
            ...dc.textAreaM,
            label: dc.buttonElement(
              (e) => {
                if (form?.current && document.hasFocus()) {
                  const alertP = alertContext?.setProp;
                  const copyStr = form.current.getFieldValue("roasting_compare_memo");
                  if (!checkEmpty(copyStr)) {
                    try {
                      navigator.clipboard.writeText(copyStr);
                      if (alertP) {
                        setTimeout(() => {
                          alertP({
                            open: true,
                            title: ta("copy"),
                            description: ta("copy_ok"),
                            useCancel: false,
                            useOk: true,
                            okFunction: () => {
                              alertP(dc.alertClose);
                            },
                          });
                        }, dc.setTimeoutDelay);
                      } else {
                        alert(ta("copy_ok"));
                      }
                    } catch (e) {}
                  }
                }
              },
              undefined,
              "link",
              t("memo_label"),
              "font-bold",
            ),
            itemClassName: dc.compareItemClassName,
            maxLength: undefined,
            showCount: false,
            read: undefined,
            saveData: false,
            textAreaProp: { rows: 10 },
            readInput: true,
            readInputDisabled: false,
            readOnly: true,
            noItem: false,
          },

          div_9: { ...dc.itemDiv, read: { display: "notNull", displayCheckIds: ["roasting_step"] } },
          roasting_step: {
            ...dc.select,
            labelClassName: dc.strongLabelClassName,
            inputClassName: dc.inputCountryClassName,
            codeGroup: "RSTEP",
            maxLength: 45,
            showCount: true,
            read: { variant: "borderless", display: "notNull" },
            create: { defaultValue: "RSRV" },
          },
          div_10: { ...dc.itemDiv },
          rgst_info: dc.rgst,
          edit_info: dc.edit,
        },
        tempValue: { ...dc.tempPublicStage },
        listClickFetch: { fetchUrl: "/api/roaster/roasting/result/detail/" },
        listClickButton: {
          order: 0,
          iconName: "ChartLine",
          display: "notNull",
          displayCheckIds: [
            "roasting_dried_term",
            "roasting_first_start_term",
            "roasting_first_end_term",
            "roasting_second_start_term",
            "roasting_end_bean",
          ],
        },
        listClickMulti: 10,
        listClickTitle: {
          field: "roasting_check",
          fieldId: {
            roasting_name: { fieldId: params?.locale === enLocale ? "roasting_name" : "roasting_name_locale" },
            roasting_result_date: {},
            roasting_batch_no: {},
            roasting_loss: dc.lossRate,
          },
          valueJoin: " - ",
        },
        listClick: (dataFetch: { url: string; option: any; dataId: string; title: string }) => {
          Debug(dataFetch);
          fetchHost(dataFetch.url, dataFetch.option, props.params?.auth, (data: any) => {
            Debug("RoastingResult List Click", data);
            const tempData = data.result
              ? {
                  ...data.result.roasting_result_profile,
                  roasting_name:
                    params?.locale === enLocale
                      ? data.result.roasting_result.roasting_name
                      : data.result.roasting_result.roasting_name_locale,
                  roasting_result_date: data.result.roasting_result.roasting_result_date,
                  roasting_batch_no: data.result.roasting_result.roasting_batch_no,
                  roasting_loss: data.result.roasting_result.roasting_loss,
                  roasting_mass: data.result.roasting_result.roasting_mass,
                  roasting_result_memo: data.result.roasting_result.roasting_result_memo,
                }
              : undefined;
            const summaryFieldId = roastingSummaryFieldIdExp(" | ");
            const org_values = getInputValuesCheck(
              form?.current,
              formMemo?.current,
              dataFunction?.current,
              undefined,
              { roasting_start_bean: getPrevTemp(undefined), ...summaryFieldId },
              true,
            );
            Debug("org_values : ", org_values ? { ...org_values } : undefined);
            // const roastingSeries = getRoastingSeriesInput(form?.current, formMemo?.current, dataFunction?.current);
            // const cal = getRoastingSeriesCalcLossRatio(roastingSeries);
            // Debug("roastingSeries Calc: ", cal);
            // const org = getSummaryValues(
            //   t,
            //   { field: "roasting_org_summary", fieldId: { ...summaryFieldId }, valueJoin: "" },
            //   undefined,
            //   org_values,
            //   params?.locale,
            //   true,
            // );
            const compare = getSummaryValues(
              t,
              { field: "roasting_compare_summary", fieldId: { ...summaryFieldId }, valueJoin: "" },
              undefined,
              tempData,
              params?.locale,
              true,
            );
            const diffFieldIdList = roastingSummaryFieldIdExp(true);
            const diffFields = Object.keys(diffFieldIdList);
            const diffFieldId: Record<string, DataInputCommonParams> = {};
            diffFields.forEach((field) => {
              org_values[field + "_check"] = tempData[field];
              diffFieldId[field + "_diff"] = {
                ...diffFieldIdList[field],
                calcValueProp: { input1: field, mode: "-", input2: field + "_check" },
                sign: true,
              };
            });
            const diff = getSummaryValues(
              t,
              { field: "roasting_compare_diff", fieldId: { ...diffFieldId }, valueJoin: "" },
              undefined,
              org_values,
              params?.locale,
              true,
            );
            const memo = getSummaryValues(
              t,
              {
                field: "roasting_result_memo",
                itemClassName: "whitespace-pre-wrap text-start",
              },
              undefined,
              tempData,
              params?.locale,
              true,
            );
            // Debug(org);
            updateCompareProfile(
              form?.current,
              formFunction?.current,
              formMemo?.current,
              dataFunction?.current,
              params?.locale,
              dataFetch.dataId,
              dataFetch.title,
              tempData,
              undefined,
              diff,
              compare,
              memo,
            );
          });
        },
        listCancelButton: { order: 0, iconName: "X" },
        listCancel: (dataFetch: { url: string; option: any; dataId: string; title: string | undefined }) => {
          Debug(dataFetch);
          updateCompareProfile(
            form?.current,
            formFunction?.current,
            formMemo?.current,
            dataFunction?.current,
            params?.locale,
            dataFetch.dataId,
            dataFetch.title,
            undefined,
            undefined,
          );
        },
        listEdit: {
          field: "roasting_instock",
          button: {
            onClick: (chageValues: any[] | undefined) => {
              listEditClickCommon(
                t,
                ta,
                dataFunction?.current,
                alertContext,
                "/api/roaster/roasting/result/instock/update",
                params?.auth,
                "instock_list",
                chageValues,
              );
            },
          },
        },

        listShow: true,
        listColDesc: [
          {
            field: "roasting_summary_1",
            fieldId: {
              roasting_first_start_term: {
                ...dc.timer,
                prev: { element: "roasting_first_start_term", transition: true },
                unitPrev: " : ",
              },
              roasting_first_start_bean: {
                ...dc.roastingTemp,
                prev: { element: "temperature", transition: true },
                unitPrev: " : ",
              },
              roasting_first_end_term: {
                ...dc.timer,
                prev: { element: "roasting_first_end_term", transition: true },
                unitPrev: " : ",
              },
              roasting_first_end_bean: {
                ...dc.roastingTemp,
                prev: { element: "temperature", transition: true },
                unitPrev: " : ",
              },
              roasting_end_term: {
                ...dc.timer,
                prev: { element: "roasting_end_term", transition: true },
                unitPrev: " : ",
              },
              roasting_end_bean: {
                ...dc.roastingTemp,
                prev: { element: "temperature", transition: true },
                unitPrev: " : ",
              },
              // roasting_turning_term: { ...dc.timer, prev: { element: "roasting_turning_term", transition: true }, unitPrev: " : " },
              // roasting_turning_bean: { ...dc.roastingTemp, prev: { element: "temperature", transition: true }, unitPrev: " : " },
              roasting_second_start_term: {
                ...dc.timer,
                prev: { element: "roasting_second_start_term", transition: true },
                unitPrev: " : ",
              },
              roasting_second_start_bean: {
                ...dc.roastingTemp,
                prev: { element: "temperature", transition: true },
                unitPrev: " : ",
              },
              roasting_second_end_term: {
                ...dc.timer,
                prev: { element: "roasting_second_end_term", transition: true },
                unitPrev: " : ",
              },
              roasting_second_end_bean: {
                ...dc.roastingTemp,
                prev: { element: "temperature", transition: true },
                unitPrev: " : ",
              },
              roasting_dried_term: {
                ...dc.timer,
                prev: { element: "roasting_dried_term", transition: true },
                unitPrev: " : ",
              },
              roasting_dried_bean: {
                ...dc.roastingTemp,
                prev: { element: "temperature", transition: true },
                unitPrev: " : ",
              },
              roasting_mass: { ...dc.mass, prev: { element: "roasting_mass", transition: true }, unitPrev: " : " },
            },
            // itemClassName: "whitespace-pre-wrap text-start",
            valueJoin: " | ",
          },
          {
            field: "roasting_result_memo",
            prev: { element: "roasting_result_memo", transition: true },
            unitPrev: " : ",
            itemClassName: "whitespace-pre-wrap text-start",
          },
        ],
        listColDescBold: ["roasting_result_date", params?.locale === enLocale ? "roasting_name" : "roasting_name_locale"],
        listColLinkField: ["roasting_result_year", "roasting_result_seq"],
        listSearch: [
          { ...dc.year, field: "search0", label: "roasting_result_year", placeholder: "roasting_result_year" },
          { ...dc.date, field: "search1", label: "roasting_result_date", placeholder: "roasting_result_date" },
          { ...dc.select, field: "search2", codeGroup: "RSTEP", label: "roasting_step", placeholder: "roasting_step" },
        ],
        listSearchSelect: [
          {
            ...dc.input,
            field: "search_title_all",
            label: "roasting_name_locale",
            placeholder: "roasting_name_locale",
          },
          // { ...dc.input, field: "search_type0", label: "roasting_name_locale", placeholder: "roasting_name_locale" },
          // { ...dc.input, field: "search_type1", label: "roasting_name", placeholder: "roasting_name" },
        ],
        listOrder: [
          "roasting_name_locale_orderdesc",
          "roasting_name_locale_orderasc",
          "roasting_batch_no_orderdesc",
          "roasting_batch_no_orderasc",
          "roasting_step_orderasc",
          "roasting_step_orderdesc",
          "roasting_result_date_orderdesc",
          "roasting_result_date_orderasc",
        ],
        listCols: [
          //"roaster_seq",
          // "roasting_result_year",
          // "roasting_result_seq",
          { field: "roasting_result_date", ...dc.date, dateFormatter: props.isMobile ? "YY-MM-DD" : "YYYY-MM-DD" },
          // "roasting_seq",
          params?.locale === enLocale ? "roasting_name" : "roasting_name_locale",
          {
            field: "roasting_batch_no",
            label: "batch_label",
            fieldId: {
              roasting_batch_no: {},
              roasting_step: { ...dc.select, codeGroup: "RSTEP", label: "step_label" },
            },
            valueJoin: " / ",
          },
          //"roasting_uuid",
          //"roasting_machine_seq",
          //"roasting_single_origin",
          //"greenbean_detail",
          //"outside_air",
          //"outside_hum",
          //"outside_hpa",
          //"inside_air",
          //"inside_hum",
          //"inside_hpa",
          // { field: "roasting_step", ...dc.select, codeGroup: "RSTEP", label: "step_label" },
          // { field: "greenbean_total_mass", ...dc.mass },
          //"greenbean_moisture",
          //"greenbean_agtron",
          // { field: "roasting_mass", ...dc.mass },
          { field: "roasting_loss", ...dc.lossRate, label: "loss_rate" },
          {
            field: "roasting_end_term",
            fieldId: {
              roasting_end_term: { ...dc.timer },
              roasting_end_term_diff: {
                ...dc.secondTimer(params?.locale),
                calcValueProp: { input1: "roasting_end_term", mode: "-", input2: "roasting_first_start_term" },
              },
            },
            valueJoin: " / ",
          },

          { ...dc.listUse, field: "roasting_instock", label: "instock_label" },
          //"roasting_moisture",
          //"roasting_agtron",
          //"roasting_result_detail",
          //"roasting_result_memo",
          //"roasting_start_time",
          //"roasting_end_term",
          //"roasting_auth",
          //"public_stage_roaster",
          //"public_stage_cafe",
          //"public_stage_customer",
          //"public_stage_normal"
        ],
        listColMobileTitle: params?.locale === enLocale ? "roasting_name" : "roasting_name_locale",
        //tempValue: dc.tempTimelineData,
      };
    case "RoastingInventory":
    default:
      return undefined;
  }
};
